import { SpringParallax } from '@ccg/core';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledTeaserOverview from './TeaserOverview.style.js';

const TeaserOverview = ({
  headline,
  subline,
  link
}) => /*#__PURE__*/React$1.createElement(StyledTeaserOverview, null, /*#__PURE__*/React$1.createElement(SpringParallax, {
  className: "teaserOverview__headline"
}, /*#__PURE__*/React$1.createElement(Typography$1, {
  as: "h2",
  variant: "intro"
}, headline)), /*#__PURE__*/React$1.createElement(SpringParallax, {
  className: "teaserOverview__excerpt"
}, /*#__PURE__*/React$1.createElement(Typography$1, {
  variant: "copy"
}, subline), link && /*#__PURE__*/React$1.createElement(Link$1, _extends({
  icon: "default",
  transform: "uppercase"
}, link), link.label)));

TeaserOverview.propTypes = {
  headline: PropTypes$1.string.isRequired,
  subline: PropTypes$1.string.isRequired,
  link: PropTypes$1.shape()
};
TeaserOverview.defaultProps = {
  link: null
};

export default TeaserOverview;
